import { ref, Ref, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';

export default function useElementSeen(callback?: () => void) {
    const element: Ref<HTMLElement|undefined> = ref();
    const functionRef = el => {
        element.value = el;
    };

    const isVisibleOnScreen = useElementVisibility(element);
    const hasSeen = ref(false);

    watch(isVisibleOnScreen, (value) => {
        if (value && !hasSeen.value) {
            if (callback) {
                callback();
            }
            hasSeen.value = true;
        }
    }, { immediate: true });

    return functionRef;
}
